import type { ReactNode } from "react";

type Tone = "default" | "brand" | "up" | "down" | "warn" | "info";
type Size = "xs" | "sm";

const toneClass: Record<Tone, string> = {
  default: "bg-surface-2 text-fg-subtle border-border",
  brand:
    "bg-brand-50 text-brand-700 border-brand-200 dark:bg-brand-500/10 dark:text-brand-300 dark:border-brand-400/30",
  up:
    "bg-up-50 text-up-700 border-up-200 dark:bg-up-500/10 dark:text-up-400 dark:border-up-400/30",
  down:
    "bg-down-50 text-down-700 border-down-200 dark:bg-down-500/10 dark:text-down-400 dark:border-down-400/30",
  warn:
    "bg-warn-50 text-warn-700 border-warn-200 dark:bg-warn-500/10 dark:text-warn-400 dark:border-warn-400/30",
  info:
    "bg-info-50 text-info-700 border-info-200 dark:bg-info-500/10 dark:text-info-400 dark:border-info-400/30",
};

const sizeClass: Record<Size, string> = {
  xs: "text-[10px] px-1.5 py-0",
  sm: "text-xs px-2 py-0.5",
};

export default function Chip({
  children,
  tone = "default",
  size = "sm",
  mono = false,
  className = "",
}: {
  children: ReactNode;
  tone?: Tone;
  size?: Size;
  mono?: boolean;
  className?: string;
}) {
  return (
    <span
      className={`inline-block rounded border ${toneClass[tone]} ${sizeClass[size]} ${mono ? "font-mono" : "font-medium"} ${className}`}
    >
      {children}
    </span>
  );
}
